import { Box, Typography, useTheme } from "@mui/material";
import { SocialIcons } from "../SocialIcons";

export function Footer() {
  const theme = useTheme();
  return (
    <Box
      component="footer"
      sx={{
        height: 100,
        bgcolor: theme.palette.grey[900],
        color: theme.palette.common.white,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "flex-end",
        p: 1,
      }}
    >
      <Box sx={{ mb: 1 }}>
        <SocialIcons />
      </Box>

      <Typography variant="body2" align="center">
        © 2025 Restituir Soluções. Todos os direitos reservados.
      </Typography>
    </Box>
  );
}
